var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M960 252.736L771.008 64H86.4a22.528 22.528 0 0 0-22.4 22.4v851.2c0 12.352 10.112 22.4 22.4 22.4h851.2c12.288 0 22.4-10.048 22.4-22.4v-215.36a22.4 22.4 0 0 0-44.864 0V596.032h0.256c0 0.512-0.256 0.896-0.256 1.344a22.4 22.4 0 1 0 44.864 0c0-0.512-0.256-0.896-0.256-1.344H960v-96h-0.32c0.064-0.576 0.32-1.088 0.32-1.6a22.4 22.4 0 0 0-44.864 0c0 0.576 0.256 1.024 0.32 1.6H915.2V414.976h0.064l-0.064 0.384a22.4 22.4 0 0 0 44.8 0.064l-0.064-0.384H960V252.736z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 915.2V108.8h643.648L915.2 271.296V915.2z",
    fill: "#d86e18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.984 64v203.584c0 12.288 10.112 22.4 22.4 22.4h483.2c12.288 0 22.4-10.112 22.4-22.4V64h-528z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.784 108.8h438.4v136.384h-438.4z",
    fill: "#B3B2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.984 960V548.352a22.592 22.592 0 0 0-22.464-22.4H264.32a22.528 22.528 0 0 0-22.4 22.4V960h528.064z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.784 570.816h438.4V915.2h-438.4z",
    fill: "#B3B2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.032 136h145.984v81.984H548.032z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.976 653.248c0 12.288-10.048 22.4-22.4 22.4h-275.2c-12.288 0-22.4-10.048-22.4-22.4s10.112-22.4 22.4-22.4h275.2c12.352 0 22.4 10.112 22.4 22.4zM670.976 744.64c0 12.288-10.048 22.4-22.4 22.4h-275.2c-12.288 0-22.4-10.048-22.4-22.4s10.112-22.4 22.4-22.4h275.2a22.4 22.4 0 0 1 22.4 22.4zM670.976 836.032c0 12.288-10.048 22.4-22.4 22.4h-275.2c-12.288 0-22.4-10.048-22.4-22.4s10.112-22.4 22.4-22.4h275.2a22.4 22.4 0 0 1 22.4 22.4z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.576 858.368a16 16 0 0 1-32 0V169.024a16 16 0 0 1 32 0v689.344z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveSvgrepoCom);
export default __webpack_public_path__ + "static/media/save-svgrepo-com.950f4698d3543aab722479de09614eb5.svg";
export { ForwardRef as ReactComponent };